import { api } from "@/lib/api";

const b64ToU8 = (s) => { const pad = "=".repeat((4 - (s.length % 4)) % 4); const raw = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...raw].map((c) => c.charCodeAt(0))); };
export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}
export async function enablePush() {
  if (!pushSupported()) throw new Error("This browser doesn't support push notifications");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications were blocked — allow them in your browser settings");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid");
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.public_key) }));
  await api.post("/push/subscribe", { subscription: sub.toJSON(), device: navigator.userAgent.slice(0, 80) });
  return sub;
}
export async function disablePush() {
  const sub = await currentSubscription();
  if (sub) { await api.delete("/push/subscribe", { data: { subscription: sub.toJSON() } }).catch(() => {}); await sub.unsubscribe(); }
}
